import { Link } from 'gatsby'
import React from 'react'
import PriceCard from '../UI/priceCard'
import * as styles from './prices.module.css'
import Svg1 from '../../images/svg/dollar.svg'
import { useState } from 'react'
import Modal from '../UI/modal'

const Prices = () => {
  const pricePlans = [
    {
      name: 'Start',
      price: '2990',
      desc: 'Отличный вариант для тех, у кого нет времени ждать.',
      features: ['Базовый дизайн', '2 страницы', 'Адаптивность'],
    },
    {
      name: 'Optimum',
      price: '5990',
      desc: 'Вариант для тех, кому нужен веб-сайт с продвинутым дизайном за минимальную цену.',
      features: ['Продвинутый дизайн', '3 страницы', 'Адаптивность'],
    },
    {
      name: 'E-commerce',
      price: '9900',
      desc: 'Подходящая опция для тех, кому нужен интернет магазин с легким управлением.',
      features: [
        'Продвинутый дизайн',
        '4 страницы + страницы товаров',
        'Адаптивность',
      ],
    },
  ]

  const [showModal, setShowModal] = useState(false)
  const modalHandler = () => {
    setShowModal((prev) => setShowModal(!prev))
  }

  return (
    <section>
      <div className={styles.prices}>
        <span className={styles.uiSmallText}>Наши цены</span>
        <h2>Сколько это стоит?</h2>
        <span className={styles.uiSmallText}>
          Мы предлагаем три тарифных плана на выбор
        </span>
        <div className={styles.cardContainer}>
          {pricePlans.map((el) => {
            return <PriceCard price={el} key={el.name} onClick={modalHandler} />
          })}
        </div>
        <div className={styles.compareRates}>
          <Svg1 />
          <h3>Сравнить тарифы</h3>
          <span>
            Узнайте больше о том, чем различаются тарифы и выберите лучшую опцию
          </span>
          <Link to="/prices">УЗНАТЬ БОЛЬШЕ</Link>
        </div>
      </div>
      <Modal onClose={modalHandler} show={showModal} />
    </section>
  )
}

export default Prices
